import { red } from '@mui/material/colors'
import { components } from './components'

const themeOptions = {
    typography: {
        fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
        body1: {
            fontSize: '14px',
        },
        h1: {
            fontWeight: 600,
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        h4: {
            fontWeight: 600,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 500,
        },
    },
    status: {
        danger: red[500],
    },
    components: {
        ...components,
    },
}

export default themeOptions
